<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">{{ title() }}</div>
    <div class="sopo-popup-text">{{ message() }}</div>
    <app-points-progress-bar [necessaryPoints]="necessaryPoints()" [currentPoints]="currentPoints()" />
    <div class="sopo-popup-button-container">
        <div class="sopo-popup-green-button clickable" (click)="close()">OK</div>
    </div>
</div>
